import list from './list'

const places =
{
    ...list,
    helmet :
    {
        title : 'Lieux' ,
        metas : []
    },
    empty  : 'Aucun lieu trouvé',
    search : 'Rechercher un lieu ...' ,
    title  : 'Lieux'
};

export default places ;
